window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() {
	dataLayer.push(arguments);
};
gtag('js', new Date());
gtag('config', 'UA-5192617-57');
gtag('config', 'UA-5192617-62');
// gtag('config', 'G-0HPMCG420W', { send_page_view: false });
